module.exports = __webpack_public_path__ + "img/Boily.54c7ad1a.png";